<template>
  <svg ref="svgEl" class="barcode-svg"></svg>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
  name: 'BarcodeLabel',

  props: {
    studentId: { type: [Number, String], required: true },
    barWidth:  { type: Number, default: 2 },
    barHeight: { type: Number, default: 60 },
  },

  methods: {
    render() {
      const el = this.$refs.svgEl;
      if (!el || !this.studentId) return;
      try {
        JsBarcode(el, `STU-${this.studentId}`, {
          format:        'CODE128',
          lineColor:     '#000',
          background:    '#fff',
          width:         this.barWidth,
          height:        this.barHeight,
          displayValue:  true,
          text:          `STU-${this.studentId}`,
          fontOptions:   'bold',
          font:          'monospace',
          textAlign:     'center',
          textPosition:  'bottom',
          fontSize:       13,
          textMargin:     4,
          margin:         8,
        });
      } catch {}
    },

    downloadPng(filename) {
      const svgEl = this.$refs.svgEl;
      if (!svgEl) return;

      const w = parseFloat(svgEl.getAttribute('width'))  || 220;
      const h = parseFloat(svgEl.getAttribute('height')) || 90;

      const svgData = new XMLSerializer().serializeToString(svgEl);
      const blob    = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const url     = URL.createObjectURL(blob);

      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width  = w * 2;
        canvas.height = h * 2;
        const ctx = canvas.getContext('2d');
        ctx.scale(2, 2);
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, w, h);

        const link = document.createElement('a');
        link.download = filename || `barcode-STU-${this.studentId}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
        URL.revokeObjectURL(url);
      };
      img.src = url;
    },
  },

  mounted()  { this.$nextTick(this.render); },

  watch: {
    studentId() { this.$nextTick(this.render); },
    barWidth()  { this.$nextTick(this.render); },
    barHeight() { this.$nextTick(this.render); },
  },
};
</script>

<style scoped>
.barcode-svg {
  display: block;
}
</style>
